import styled from "styled-components";

export const SidebarWidgetStyled = styled.div`
  min-height: 100%;
  width: ${({ $collapsed }) => ($collapsed ? "64px" : "238px")};
  background: ${({ theme }) => theme.COLORS.BLUE_5};
  transition: width 0.25s ease;
  .s_logo_sec {
    position: relative;
    padding: 1rem;
    height: 77px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    .sidebar_logo {
      width: ${({ $collapsed }) => ($collapsed ? "44px" : "170px")};
      max-width: 100%;
      height: auto;
      object-fit: contain;
      display: block;
      transition: width 0.25s ease;
    }
  }
  .s_menu_sec {
    margin: 0px;
    padding: 0px;
    list-style: none;
    .s_menu_item {
      position: relative;
      padding: ${({ $collapsed }) =>
        $collapsed ? "1rem 0.5rem" : "1rem 1.5rem"};
      display: flex;
      align-items: center;
      justify-content: ${({ $collapsed }) =>
        $collapsed ? "center" : "flex-start"};
      column-gap: ${({ $collapsed }) => ($collapsed ? "0" : "0.75rem")};
      cursor: pointer;
      transition: all 0.3s ease;
      svg {
        transition: all 0.3s ease;
      }
      .s_menu_icon {
        position: relative;
        flex: none;
        display: flex;
        align-items: center;
        justify-content: center;
        .s_menu_alert_dot {
          position: absolute;
          top: -2px;
          right: -2px;
          width: 9px;
          height: 9px;
          border-radius: 50%;
          background: ${({ theme }) => theme.COLORS.RED_1 || "#e03131"};
          display: ${({ $collapsed }) => ($collapsed ? "block" : "none")};
        }
      }
      .s_menu_label {
        white-space: nowrap;
        overflow: hidden;
        opacity: ${({ $collapsed }) => ($collapsed ? 0 : 1)};
        width: ${({ $collapsed }) => ($collapsed ? "0" : "auto")};
        transition: opacity 0.2s ease;
      }
      .s_menu_tooltip {
        position: absolute;
        left: calc(100% + 12px);
        top: 50%;
        transform: translateY(-50%);
        white-space: nowrap;
        background: ${({ theme }) => theme.COLORS.BLACK_1 || "#1a1a1a"};
        color: ${({ theme }) => theme.COLORS.WHITE_1 || "#ffffff"};
        padding: 0.4rem 0.75rem;
        border-radius: 6px;
        font-size: 0.85rem;
        pointer-events: none;
        opacity: 0;
        visibility: hidden;
        z-index: 50;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        &::before {
          content: "";
          position: absolute;
          right: 100%;
          top: 50%;
          transform: translateY(-50%);
          border: 6px solid transparent;
          border-right-color: ${({ theme }) => theme.COLORS.BLACK_1 || "#1a1a1a"};
        }
      }
      &:hover .s_menu_tooltip {
        opacity: 1;
        visibility: visible;
      }
      &:hover {
        background: ${({ theme }) => theme.COLORS.GRAY_4};
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        svg {
          color: ${({ theme }) => theme.COLORS.PURPLE_1};
          fill: ${({ theme }) => theme.COLORS.PURPLE_1};
        }
      }
      &.active {
        background: ${({ theme }) => theme.COLORS.PURPLE_5};
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
      }
    }
  }
`;
